import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './KidsSpace.css';

const KidsSpace = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <section className="kids-teaser-section">
      <div className="kids-teaser-inner">
        <div className="kids-teaser-image-col">
          <div className="kids-teaser-img-wrap">
            <img
              src="/images/tideasoliskids/whole.jpeg"
              alt="TiDea Solis Kids priestor"
              className="kids-teaser-img"
            />
          </div>
        </div>

        <div className="kids-teaser-text-col">
          <div className="kids-teaser-logo-row">
            <img
              src="/images/tideasoliskids/kidslogo.jpeg"
              alt="TiDea Solis Kids logo"
              className="kids-teaser-logo"
            />
            <span className="kids-teaser-brand">TiDea Solis Kids</span>
          </div>
          <div className="kids-teaser-divider"></div>
          <h2 className="kids-teaser-heading">{t('kids_space.teaser_tagline')}</h2>
          <p className="kids-teaser-intro">{t('kids_space.teaser_intro')}</p>
          <button
            className="kids-teaser-btn"
            onClick={() => navigate('/kids-space')}
          >
            {t('kids_space.explore_btn')} &rarr;
          </button>
        </div>
      </div>
    </section>
  );
};

export default KidsSpace;
